///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export class GtthDataUtils {
    static toBase64(file: File, cb: (data: any) => void) {
        const fileReader: FileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = (e: any) => {
            const base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
            cb(base64Data);
        };
    }
}
